export default __webpack_public_path__ + "static/media/ZKTeco.801dfb26.png";